// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Raleway:wght@300;400;500;600;700;900&family=Roboto:wght@300;400;500;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Fjalla+One&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button, .button {
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size:18px;
}

h1, .h1 {
  font-family: 'Raleway', sans-serif;
  font-weight: 700;
  font-size:48px;
}

h2, .h2 {
  font-family: 'Raleway', sans-serif;
  font-weight: 700;
  font-size:36px;
}

h3, .h3 {
  font-family: 'Raleway', sans-serif;
  font-weight: 700;
  font-size:30px;
}

h4, .h4 {
  font-family: 'Raleway', sans-serif;
  font-weight: 700;
  font-size:24px;
}

h5, .h5 {
  font-family: 'Raleway', sans-serif;
  font-weight: 700;
  font-size:20px;
}

h6, .h6 {
  font-family: 'Raleway', sans-serif;
  font-weight: 700;
  font-size:18px;
}

a, p, span, label, .body-1, .p {
  font-family: 'Roboto', sans-serif;
  font-size:16px;
  line-height: 150%;
}

b, .bold {
  font-family: 'Roboto', sans-serif;
  font-size:18px;
  font-weight: 700;
}

a, .link {
  background: none;
  border: none;
  color: #526AF2;
  cursor: pointer;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 18px;
  text-decoration: underline;
}

a:hover, .link:hover {
  color: #404FA1;
}

.body-2 {
  font-family: 'Roboto', sans-serif;
  font-size:16px;
}

.caption {
  font-family: 'Roboto', sans-serif;
  font-size:14px;
}

.subtitle-1 {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 130%;
  text-transform: uppercase;
}

.subtitle-2 {
  font-family: 'Raleway', sans-serif;
  font-size:16px;
}

@media screen and (max-width: 480px) {
  button, .button {
    font-family: 'Roboto', sans-serif;
    font-weight: 500;
    font-size:18px;
  }

  h1, .h1 {
    font-family: 'Raleway', sans-serif;
    font-weight: 700;
    font-size:40px;
  }

  h2, .h2 {
    font-family: 'Raleway', sans-serif;
    font-weight: 700;
    font-size:36px;
  }

  h3, .h3 {
    font-family: 'Raleway', sans-serif;
    font-weight: 700;
    font-size:30px;
  }

  h4, .h4 {
    font-family: 'Raleway', sans-serif;
    font-weight: 700;
    font-size:20px;
  }

  h5, .h5 {
    font-family: 'Raleway', sans-serif;
    font-weight: 700;
    font-size:18px;
  }

  h6, .h6 {
    font-family: 'Raleway', sans-serif;
    font-weight: 700;
    font-size:16px;
  }

  a, p, span, label, .body-1, .p {
    font-family: 'Roboto', sans-serif;
    font-size:14px;
    line-height: 150%;
  }

  b, .bold {
    font-family: 'Roboto', sans-serif;
    font-size:16px;
    font-weight: 700;
  }

  a, .link {
    background: none;
    border: none;
    color: #526AF2;
    cursor: pointer;
    font-family: 'Roboto', sans-serif;
    font-weight: 500;
    font-size: 16px;
    text-decoration: none;
  }

  a:hover, .link:hover {
    color: #404FA1;
  }

  .body-2 {
    font-family: 'Roboto', sans-serif;
    font-size:14px;
  }

  .caption {
    font-family: 'Roboto', sans-serif;
    font-size:13px;
  }

  .subtitle-2 {
    font-family: 'Raleway', sans-serif;
    font-size:16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/library/style/typography.css"],"names":[],"mappings":"AAGA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE;IACE,iCAAiC;IACjC,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,kCAAkC;IAClC,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,kCAAkC;IAClC,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,kCAAkC;IAClC,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,kCAAkC;IAClC,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,kCAAkC;IAClC,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,kCAAkC;IAClC,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,iCAAiC;IACjC,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,iCAAiC;IACjC,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,iCAAiC;IACjC,gBAAgB;IAChB,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iCAAiC;IACjC,cAAc;EAChB;;EAEA;IACE,iCAAiC;IACjC,cAAc;EAChB;;EAEA;IACE,kCAAkC;IAClC,cAAc;EAChB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Raleway:wght@300;400;500;600;700;900&family=Roboto:wght@300;400;500;700&display=swap');\r\n@import url('https://fonts.googleapis.com/css2?family=Fjalla+One&display=swap');\r\n\r\nbutton, .button {\r\n  font-family: 'Roboto', sans-serif;\r\n  font-weight: 500;\r\n  font-size:18px;\r\n}\r\n\r\nh1, .h1 {\r\n  font-family: 'Raleway', sans-serif;\r\n  font-weight: 700;\r\n  font-size:48px;\r\n}\r\n\r\nh2, .h2 {\r\n  font-family: 'Raleway', sans-serif;\r\n  font-weight: 700;\r\n  font-size:36px;\r\n}\r\n\r\nh3, .h3 {\r\n  font-family: 'Raleway', sans-serif;\r\n  font-weight: 700;\r\n  font-size:30px;\r\n}\r\n\r\nh4, .h4 {\r\n  font-family: 'Raleway', sans-serif;\r\n  font-weight: 700;\r\n  font-size:24px;\r\n}\r\n\r\nh5, .h5 {\r\n  font-family: 'Raleway', sans-serif;\r\n  font-weight: 700;\r\n  font-size:20px;\r\n}\r\n\r\nh6, .h6 {\r\n  font-family: 'Raleway', sans-serif;\r\n  font-weight: 700;\r\n  font-size:18px;\r\n}\r\n\r\na, p, span, label, .body-1, .p {\r\n  font-family: 'Roboto', sans-serif;\r\n  font-size:16px;\r\n  line-height: 150%;\r\n}\r\n\r\nb, .bold {\r\n  font-family: 'Roboto', sans-serif;\r\n  font-size:18px;\r\n  font-weight: 700;\r\n}\r\n\r\na, .link {\r\n  background: none;\r\n  border: none;\r\n  color: #526AF2;\r\n  cursor: pointer;\r\n  font-family: 'Roboto', sans-serif;\r\n  font-weight: 400;\r\n  font-size: 18px;\r\n  text-decoration: underline;\r\n}\r\n\r\na:hover, .link:hover {\r\n  color: #404FA1;\r\n}\r\n\r\n.body-2 {\r\n  font-family: 'Roboto', sans-serif;\r\n  font-size:16px;\r\n}\r\n\r\n.caption {\r\n  font-family: 'Roboto', sans-serif;\r\n  font-size:14px;\r\n}\r\n\r\n.subtitle-1 {\r\n  font-family: Roboto;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 18px;\r\n  line-height: 130%;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.subtitle-2 {\r\n  font-family: 'Raleway', sans-serif;\r\n  font-size:16px;\r\n}\r\n\r\n@media screen and (max-width: 480px) {\r\n  button, .button {\r\n    font-family: 'Roboto', sans-serif;\r\n    font-weight: 500;\r\n    font-size:18px;\r\n  }\r\n\r\n  h1, .h1 {\r\n    font-family: 'Raleway', sans-serif;\r\n    font-weight: 700;\r\n    font-size:40px;\r\n  }\r\n\r\n  h2, .h2 {\r\n    font-family: 'Raleway', sans-serif;\r\n    font-weight: 700;\r\n    font-size:36px;\r\n  }\r\n\r\n  h3, .h3 {\r\n    font-family: 'Raleway', sans-serif;\r\n    font-weight: 700;\r\n    font-size:30px;\r\n  }\r\n\r\n  h4, .h4 {\r\n    font-family: 'Raleway', sans-serif;\r\n    font-weight: 700;\r\n    font-size:20px;\r\n  }\r\n\r\n  h5, .h5 {\r\n    font-family: 'Raleway', sans-serif;\r\n    font-weight: 700;\r\n    font-size:18px;\r\n  }\r\n\r\n  h6, .h6 {\r\n    font-family: 'Raleway', sans-serif;\r\n    font-weight: 700;\r\n    font-size:16px;\r\n  }\r\n\r\n  a, p, span, label, .body-1, .p {\r\n    font-family: 'Roboto', sans-serif;\r\n    font-size:14px;\r\n    line-height: 150%;\r\n  }\r\n\r\n  b, .bold {\r\n    font-family: 'Roboto', sans-serif;\r\n    font-size:16px;\r\n    font-weight: 700;\r\n  }\r\n\r\n  a, .link {\r\n    background: none;\r\n    border: none;\r\n    color: #526AF2;\r\n    cursor: pointer;\r\n    font-family: 'Roboto', sans-serif;\r\n    font-weight: 500;\r\n    font-size: 16px;\r\n    text-decoration: none;\r\n  }\r\n\r\n  a:hover, .link:hover {\r\n    color: #404FA1;\r\n  }\r\n\r\n  .body-2 {\r\n    font-family: 'Roboto', sans-serif;\r\n    font-size:14px;\r\n  }\r\n\r\n  .caption {\r\n    font-family: 'Roboto', sans-serif;\r\n    font-size:13px;\r\n  }\r\n\r\n  .subtitle-2 {\r\n    font-family: 'Raleway', sans-serif;\r\n    font-size:16px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
